import React from 'react';

export const ScrollProvider = React.createContext();